import { Datatable, SearchHeader, SubHeader } from "../../../../common";
import { deleteCategory, getCategories } from "../../../../../api";
import { useLanguage } from "../../../../../context";
import { useNavigate } from "react-router-dom";
import { Icon } from "../../../../Libraries";
import { useEffect, useState } from "react";

const CategoryList = () => {

    const { I18n } = useLanguage();
    let navigate = useNavigate();

    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    const [pagination, setPagination] = useState({
        resultsPerPage: 10,
        totalCount: 0,
        page: 1,
    });

    useEffect(() => {
        handleCategories();
    }, []);

    const onDelete = async (id) => {
        try {
            const data = await deleteCategory(id, { archive: true });
            if (data.success) handleCategories();
        } catch (err) { }
    };

    const handleCategories = async (reqPage = 1, filters = undefined) => {
        try {
            setLoading(true);

            let params = {
                resultsPerPage: pagination.resultsPerPage,
                page: reqPage
            };

            if (filters) params = { ...params, ...filters };

            const { data } = await getCategories(params);
            const { resultsPerPage, totalCount, categories, page } = data || {};

            setPagination({ resultsPerPage, totalCount, page });
            setList(categories.map(category => {
                return {
                    nameLocal: category.nameLocal || '',
                    isActive: category.isActive || '',
                    createdAt: category.createdAt,
                    name: category.name || '',
                    image: category.image,
                    code: category.code,
                    _id: category._id,
                }
            }));

        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    };

    const onPageChange = (page) => {
        if (page == pagination.current || loading) return;
        handleCategories(page);
    };

    const AddCategory = () => navigate('/category/create');
    const ImportCategory = () => { };

    return (
        <div className="page-wrapper">
            <div className="content">
                <SubHeader
                    data={{
                        subTitle: 'manage_ur_categories',
                        title: 'category_list',
                        overlays: [
                            {
                                svg: 'assets/img/icons/pdf.svg',
                                tipType: I18n.pdf
                            },
                            {
                                svg: 'assets/img/icons/excel.svg',
                                tipType: I18n.excel
                            },
                            {
                                onClick: handleCategories,
                                Icon: Icon['referesh'],
                                tipType: I18n.refresh,
                                disabled: loading
                            }
                        ],
                        actions: [
                            {
                                className: 'btn btn-added',
                                title: 'add_new_category',
                                action: AddCategory,
                                icon: 'plus',

                            },
                            {
                                className: 'btn btn-added color',
                                title: 'import_category',
                                action: ImportCategory,
                                icon: 'download',
                            }
                        ],
                    }}
                />

                <div className="card table-list-card">
                    <div className="card-body">
                        <SearchHeader applyFilter={handleCategories} />

                        <div className="table-responsive">
                            <Datatable
                                onPageChange={onPageChange}
                                pagination={pagination}
                                onDelete={onDelete}
                                loading={loading}
                                dataSource={list}
                                noOfColumns={5}
                                type="category"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CategoryList;